import { ReloadChange } from '../OperatorActions/reloadItems/ReloadOperation.interface'

export const getChangeName = (change: ReloadChange) => {
  return change.processItemUuid
}
